import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Chip,
  Stack,
} from "@mui/material";
import { CloudUpload, Close } from "@mui/icons-material";
import apiEndpoints from "../../apiconfig";

const UploadIdProof = ({
  form,
  handleSingleImageUpload,
  setField,
  showErrors,
}) => {
  const inputRef = React.useRef();

  // Helper function to get the image URL regardless of format
  const getImageUrl = (imageData) => {
    if (!imageData) return null;
    if (typeof imageData === "string") return imageData; // API returns string URL
    if (typeof imageData === "object" && imageData.url) return imageData.url; // New upload
    return null;
  };

  // Helper function to get the image name
  const getImageName = (imageData) => {
    if (!imageData) return "";
    if (typeof imageData === "string") return "Existing ID proof";
    if (typeof imageData === "object" && imageData.name) return imageData.name;
    return "Unknown";
  };

  const imageUrl = getImageUrl(form.ID_proof);

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Aadhaar Card (Image)
      </Typography>

      {showErrors && !imageUrl && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          ID proof is required
        </Typography>
      )}

      <Card
        variant="outlined"
        sx={{ borderStyle: "dashed", mb: 2, cursor: "pointer" }}
        onClick={() => inputRef.current?.click()}
      >
        <CardContent sx={{ textAlign: "center" }}>
          <CloudUpload sx={{ fontSize: 44, mb: 1 }} />
          <Typography>Click to choose an image (JPG/PNG)</Typography>
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png"
            style={{ display: "none" }}
            onChange={(e) => handleSingleImageUpload(e, "ID_proof")}
          />
        </CardContent>
      </Card>

      {imageUrl && (
        <Stack direction="row" spacing={2} alignItems="center">
          <img
            src={
              typeof form.ID_proof === "object"
                ? imageUrl
                : `${apiEndpoints.image}${imageUrl}`
            }
            alt={getImageName(form.ID_proof)}
            style={{
              width: 140,
              height: 140,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton onClick={() => setField("ID_proof", null)}>
              <Close />
            </IconButton>
          </Stack>
        </Stack>
      )}
    </Box>
  );
};

export default UploadIdProof;
